<div class="container-fluid">
  <!-- loader -->
  <div *appLoading></div>
  <app-header></app-header>
  <app-menu></app-menu>
  <app-toasts></app-toasts>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
